(function () {
  const GEO = window.BLOOM_INDIA_GEO || {};
  const STORAGE_KEY = GEO.storageKey || 'bloom-geo-country:v1';
  const DOLLAR_RE = /(?:US)?\$[\d,]+(?:\.\d{2})?(?:\s*USD)?/gi;
  const USD_TO_INR = 94.96;
  let detectedCountry = '';
  let observer = null;
  let scheduled = false;
  let resumeOnClose = false;

  function openSelect() {
    const el = document.activeElement;
    if (!el || !el.matches) return null;
    if (el.matches('select')) return el;
    return null;
  }

  function getMap() {
    return window.BLOOM_INDIA_PRICE_MAP || { byId: {}, byHandleVariant: {} };
  }

  function getCachedCountry() {
    try {
      return String(sessionStorage.getItem(STORAGE_KEY) || '').toUpperCase();
    } catch (error) {
      return '';
    }
  }

  function setCachedCountry(country) {
    try {
      sessionStorage.setItem(STORAGE_KEY, country);
    } catch (error) {}
  }

  function isEnabled() {
    return GEO.enabled !== false;
  }

  function isIndia() {
    if (!isEnabled()) return false;
    const params = new URLSearchParams(window.location.search);
    const forced = (params.get('bloom_country') || '').toUpperCase();
    if (forced === 'IN') return true;
    if (forced === 'US') return false;
    const liquid = String((GEO && GEO.liquidCountry) || '').toUpperCase();
    const cached = getCachedCountry();
    const detected = String(detectedCountry || '').toUpperCase();
    return liquid === 'IN' || cached === 'IN' || detected === 'IN';
  }

  function formatRs(amount) {
    const value = Number(amount);
    if (!Number.isFinite(value)) return '';
    try {
      return 'Rs. ' + new Intl.NumberFormat('en-IN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    } catch (error) {
      return 'Rs. ' + value.toFixed(2);
    }
  }

  function usdToInrAmount(amount) {
    const value = Number(amount);
    if (!Number.isFinite(value)) return null;
    return Math.round(value * USD_TO_INR * 100) / 100;
  }

  function translateUsd(amount) {
    const converted = usdToInrAmount(amount);
    if (converted == null) return '';
    return formatRs(converted);
  }

  function translateDollarString(text) {
    const source = String(text || '');
    DOLLAR_RE.lastIndex = 0;
    let next = source.replace(DOLLAR_RE, (match) => {
      const num = Number(match.replace(/[^0-9.]/g, ''));
      return translateUsd(num) || match;
    });
    next = next.replace(/([\d,]+(?:\.\d{1,2})?)\s*USD\b/gi, (match, num) => {
      const value = Number(String(num).replace(/,/g, ''));
      return translateUsd(value) || match;
    });
    return next;
  }

  function handleFromHref(href) {
    const match = String(href || '').match(/\/products\/([^\/?#]+)/i);
    if (!match) return '';
    try {
      return decodeURIComponent(match[1]).toLowerCase().trim();
    } catch (error) {
      return String(match[1] || '').toLowerCase().trim();
    }
  }

  function variantIdFromHref(href) {
    const match = String(href || '').match(/[?&]variant=(\d+)/i);
    return match ? match[1] : '';
  }

  function lookup(variantId, handle, variantTitle) {
    const byId = (getMap() && getMap().byId) || {};
    const byHandle = (getMap() && getMap().byHandleVariant) || {};
    const idKey = String(variantId || '').split('/').pop();
    if (idKey && byId[idKey]) return byId[idKey];

    const handleKey = String(handle || '').toLowerCase().trim();
    const variantKey = String(variantTitle || 'Default Title').toLowerCase().replace(/\s+/g, ' ').trim();
    if (!handleKey) return null;

    const combo = handleKey + '|' + variantKey;
    if (byHandle[combo]) return byHandle[combo];

    const days = variantKey.match(/\b(40|80|160)\b/);
    if (days && byHandle[handleKey + '|' + days[1] + ' days']) {
      return byHandle[handleKey + '|' + days[1] + ' days'];
    }
    if (byHandle[handleKey + '|default title']) return byHandle[handleKey + '|default title'];

    const prefix = handleKey + '|';
    const keys = Object.keys(byHandle).filter((key) => key.indexOf(prefix) === 0);
    if (!keys.length) return null;
    if (keys.length === 1) return byHandle[keys[0]];
    if (byHandle[handleKey + '|40 days']) return byHandle[handleKey + '|40 days'];
    return byHandle[keys[0]];
  }

  function contextFromElement(el) {
    if (!el || !el.closest) return { variantId: '', handle: '', variantTitle: '', qty: 1 };

    const tagged = el.closest('[data-bloom-variant-id]');
    const card = el.closest(
      'article, .bio-product-card, .ailment-7030__productCard, [data-product-url], [class*="bestsellers-card"], [class*="hero-carousel"], [class*="product-grid"] [class*="product"], [class*="sticky-product-bar"], [class*="ingredient-spotlight"] [class*="card"], .cart-item, tr.cart-item, product-info, .product, .product-form, form[action*="/cart/add"], [class*="ai-sc-item-"], [class*="ai-sc-upsell-item-"]'
    );

    const root = tagged || card || el;
    const hrefNode = root.querySelector ? root.querySelector('a[href*="/products/"]') : null;
    const href = (root.getAttribute && (root.getAttribute('data-product-url') || root.getAttribute('href'))) ||
      (hrefNode && hrefNode.getAttribute('href')) ||
      '';

    let variantId = (tagged && tagged.getAttribute('data-bloom-variant-id')) || variantIdFromHref(href);
    let handle = (tagged && tagged.getAttribute('data-bloom-handle')) || handleFromHref(href);
    let variantTitle = (tagged && tagged.getAttribute('data-bloom-variant-title')) || '';
    let qty = Number((tagged && tagged.getAttribute('data-bloom-qty')) || 1) || 1;

    const idField = root.querySelector
      ? root.querySelector('select[name="id"], input[name="id"]')
      : null;
    if (idField && idField.value) {
      variantId = variantId || String(idField.value).split('/').pop();
      if (idField.tagName === 'SELECT' && idField.selectedOptions && idField.selectedOptions[0]) {
        variantTitle = variantTitle || idField.selectedOptions[0].textContent;
      }
    }

    return { variantId, handle, variantTitle, qty, root };
  }

  function entryFromElement(el) {
    const ctx = contextFromElement(el);
    return lookup(ctx.variantId, ctx.handle, ctx.variantTitle);
  }

  function replacePriceNode(root, entry, qty) {
    if (!root || !entry || entry.price == null) return;
    const quantity = Number(qty) > 0 ? Number(qty) : 1;
    const sale = formatRs(entry.price * quantity);
    const compare = entry.compare != null && Number(entry.compare) > Number(entry.price)
      ? formatRs(entry.compare * quantity)
      : '';

    const saleNodes = root.querySelectorAll('.price-sale, .price span, p.price span, .h4, .bio-product-card__price span, .bio-product-card__price-current, .bio-product-card__variant-price, [class*="ai-sc-item-price-"], [class*="ai-sc-upsell-price-"]');
    const compareEl = root.querySelector('.price-compare, s, .bio-product-card__compare-price');

    if (compareEl && compare) {
      compareEl.textContent = compare;
    }
    if (saleNodes.length) {
      saleNodes.forEach((el) => {
        if (el.matches('s, .price-compare, .bio-product-card__compare-price, .bio-product-card__price-from')) return;
        if (el.classList.contains('target-price') || el.classList.contains('hidden')) return;
        if (el.textContent !== sale) el.textContent = sale;
      });
    } else if (root.childElementCount === 0 || root.matches('#total-price, .h4')) {
      root.textContent = sale;
    }
  }

  function rewriteDollarText(node, sale, compare) {
    const text = node.textContent || '';
    if (!DOLLAR_RE.test(text) && !/USD/i.test(text)) return;
    DOLLAR_RE.lastIndex = 0;
    if (node.parentElement && node.parentElement.closest('script, style, textarea, noscript, code')) return;
    if (node.parentElement && node.parentElement.closest('s, .price-compare, [class*="compare-price"]')) {
      if (compare) node.textContent = text.replace(DOLLAR_RE, compare);
      return;
    }
    node.textContent = text.replace(DOLLAR_RE, sale);
  }

  function applyPriceRoots() {
    document.querySelectorAll('[data-bloom-variant-id]').forEach((node) => {
      const entry = lookup(
        node.getAttribute('data-bloom-variant-id'),
        node.getAttribute('data-bloom-handle'),
        node.getAttribute('data-bloom-variant-title')
      );
      if (!entry) return;
      const qty = node.getAttribute('data-bloom-qty') || 1;
      replacePriceNode(node, entry, qty);
      const gridItem = node.closest('.grid-item');
      if (
        gridItem &&
        node.matches('.bio-product-card__price') &&
        entry.price != null &&
        Number(entry.price) > 0 &&
        !node.closest('.bio-native-qv-proxy')
      ) {
        const nextPrice = String(entry.price);
        if (gridItem.getAttribute('data-sort-price') !== nextPrice) {
          gridItem.setAttribute('data-sort-price', nextPrice);
        }
      }
      const sale = formatRs(entry.price * (Number(qty) || 1));
      const compare = entry.compare != null ? formatRs(entry.compare * (Number(qty) || 1)) : '';
      const walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT);
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach((textNode) => rewriteDollarText(textNode, sale, compare));
    });
  }

  function applySelectOptions() {
    document.querySelectorAll('select[name="id"] option, select.bio-product-card__variant-select option').forEach((option) => {
      const select = option.closest('select');
      if (select && document.activeElement === select) return;
      const handle = handleFromHref(
        (option.closest('[data-product-url]') && option.closest('[data-product-url]').getAttribute('data-product-url')) ||
        ((option.closest('article, form') || {}).querySelector && (option.closest('article, form').querySelector('a[href*="/products/"]') || {}).href) ||
        ''
      );
      const current = option.textContent;
      const entry = lookup(option.value, handle, current);
      let next = current;
      if (!entry) {
        next = translateDollarString(current);
      } else {
        const sale = formatRs(entry.price);
        DOLLAR_RE.lastIndex = 0;
        next = String(current || '').replace(DOLLAR_RE, sale);
      }
      if (next !== current) option.textContent = next;
    });
  }

  function sweepLeftoverDollars() {
    if (!document.body) return;
    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) {
      const text = walker.currentNode.textContent || '';
      if (DOLLAR_RE.test(text) || /\bUSD\b/.test(text)) nodes.push(walker.currentNode);
      DOLLAR_RE.lastIndex = 0;
    }
    nodes.forEach((node) => {
      const parent = node.parentElement;
      if (!parent || parent.closest('script, style, textarea, noscript, code')) return;
      const select = parent.closest('select');
      if (select && document.activeElement === select) return;
      const entry = entryFromElement(parent);
      if (!entry) {
        const translated = translateDollarString(node.textContent);
        if (translated !== node.textContent) node.textContent = translated;
        return;
      }
      const ctx = contextFromElement(parent);
      const sale = formatRs(entry.price * (ctx.qty || 1));
      const compare = entry.compare != null ? formatRs(entry.compare * (ctx.qty || 1)) : '';
      rewriteDollarText(node, sale, compare);
    });
  }

  function patchFormatMoney() {
    const helper = window.Alpine && Alpine.store && Alpine.store('xHelper');
    if (!helper || helper._bloomIndiaPatched || typeof helper.formatMoney !== 'function') return;
    const original = helper.formatMoney.bind(helper);
    helper.formatMoney = function (amount, formatString) {
      if (!isIndia()) return original(amount, formatString);
      const idField = document.querySelector(
        '.product-form [name="id"], form[action*="/cart/add"] [name="id"], [data-bloom-variant-id]'
      );
      let entry = null;
      if (idField) {
        if (idField.hasAttribute && idField.hasAttribute('data-bloom-variant-id')) {
          entry = lookup(
            idField.getAttribute('data-bloom-variant-id'),
            idField.getAttribute('data-bloom-handle'),
            idField.getAttribute('data-bloom-variant-title')
          );
        } else {
          entry = lookup(idField.value);
        }
      }
      if (!entry) entry = entryFromElement(document.querySelector('[data-bloom-variant-id]'));
      if (!entry) {
        const cents = Number(amount);
        if (!Number.isFinite(cents)) return original(amount, formatString);
        return translateUsd(cents / 100);
      }
      const unitCents = Number((document.querySelector('.target-price') || {}).textContent || 0);
      const qty = unitCents > 0 ? Number(amount) / unitCents : 1;
      if (!Number.isFinite(qty) || qty <= 0) return formatRs(entry.price);
      return formatRs(entry.price * qty);
    };
    helper._bloomIndiaPatched = true;
  }

  function sumIndiaLines(nodes) {
    let sum = 0;
    let found = 0;
    nodes.forEach((node) => {
      const entry = lookup(
        node.getAttribute('data-bloom-variant-id'),
        node.getAttribute('data-bloom-handle'),
        node.getAttribute('data-bloom-variant-title')
      );
      const qty = Number(node.getAttribute('data-bloom-qty') || 1);
      if (entry && entry.price != null) {
        sum += Number(entry.price) * qty;
        found += 1;
      }
    });
    return found ? sum : null;
  }

  function applyCartTotals() {
    const themeSum = sumIndiaLines(
      document.querySelectorAll('.cart-item[data-bloom-variant-id][data-bloom-qty], tr.cart-item[data-bloom-variant-id][data-bloom-qty]')
    );
    const total = document.getElementById('total-price');
    if (total && themeSum != null) total.textContent = formatRs(themeSum);

    document.querySelectorAll('[id^="ai-sc-subtotal-"]').forEach((el) => {
      const panel = el.closest('[id^="ai-sc-panel-"]') || document;
      const sidecartSum = sumIndiaLines(panel.querySelectorAll('[data-bloom-variant-id][data-bloom-qty]'));
      if (sidecartSum != null) el.textContent = formatRs(sidecartSum);
    });
  }

  function applyAll() {
    if (!isIndia()) return;
    if (observer) observer.disconnect();
    document.documentElement.classList.add('bloom-india');
    patchFormatMoney();
    applyPriceRoots();
    applySelectOptions();
    applyCartTotals();
    sweepLeftoverDollars();
    document.documentElement.classList.remove('bloom-india-pending');
    if (window.BloomCollectionSort && typeof BloomCollectionSort.apply === 'function') {
      BloomCollectionSort.apply();
    }
    if (observer) {
      observer.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
    }
    window.dispatchEvent(new Event('bloom-india-ready'));
  }

  function scheduleApply() {
    if (window.bloomCartQtyUiLock) return;
    if (!isIndia() || scheduled) return;
    const select = openSelect();
    if (select) {
      if (resumeOnClose) return;
      resumeOnClose = true;
      const resume = () => {
        resumeOnClose = false;
        scheduleApply();
      };
      select.addEventListener('blur', resume, { once: true });
      return;
    }
    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      applyAll();
    });
  }

  function parseDetectedCountry(payload) {
    const detected = payload && payload.detected_values;
    const country = detected && detected.country;
    if (typeof country === 'string' && country.trim()) return country.trim().toUpperCase();
    if (country && typeof country === 'object') {
      const handle = country.handle || country.iso_code || country.isoCode;
      return handle ? String(handle).trim().toUpperCase() : '';
    }
    return '';
  }

  async function detectCountry() {
    try {
      const response = await fetch('/browsing_context_suggestions.json', { credentials: 'same-origin' });
      if (!response.ok) return '';
      return parseDetectedCountry(await response.json());
    } catch (error) {
      return '';
    }
  }

  function forceIndiaLocalization() {
    if (!isEnabled()) return false;
    if (!GEO.indiaAvailable) return false;
    if (String(GEO.liquidCountry || '').toUpperCase() === 'IN') return false;
    const form = document.getElementById('bloom-india-geo-form');
    if (!form || form.dataset.bloomSubmitted === 'true') return false;
    form.dataset.bloomSubmitted = 'true';
    form.submit();
    return true;
  }

  function observe() {
    if (observer) return;
    observer = new MutationObserver(scheduleApply);
    observer.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  }

  async function init() {
    if (!isEnabled()) {
      document.documentElement.classList.remove('bloom-india', 'bloom-india-pending');
      window.dispatchEvent(new Event('bloom-india-ready'));
      return;
    }

    if (isIndia()) {
      applyAll();
      observe();
    }

    const params = new URLSearchParams(window.location.search);
    const forced = (params.get('bloom_country') || '').toUpperCase();
    if (forced === 'IN' || forced === 'US') {
      detectedCountry = forced;
      setCachedCountry(forced);
    } else {
      detectedCountry = await detectCountry();
      if (detectedCountry) setCachedCountry(detectedCountry);
    }

    if (detectedCountry === 'IN') {
      if (forceIndiaLocalization()) return;
      applyAll();
      observe();
      return;
    }

    if (!isIndia()) {
      document.documentElement.classList.remove('bloom-india', 'bloom-india-pending');
    }
  }

  window.BloomIndia = {
    isIndia,
    lookup,
    formatRs,
    usdToInrAmount,
    translateUsd,
    formatLine: function (variantId, handle, variantTitle, qty) {
      if (!isIndia()) return '';
      const entry = lookup(variantId, handle, variantTitle);
      if (!entry || entry.price == null) return '';
      const quantity = Number(qty) > 0 ? Number(qty) : 1;
      return formatRs(entry.price * quantity);
    },
    apply: function () {
      if (!isIndia()) return;
      applyAll();
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
